import styled from 'styled-components'

export const MainModalDown = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

export const ModalDownContent = styled.div`
  width: 90%;
  max-width: 450px;
  background-color: #02045c;
  background-image: linear-gradient(135deg, #02045c 0%, #0a1128 100%);
  border-radius: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 32px 24px;
  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);

  animation: modalFadeIn 400ms cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.9) translateY(20px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  .close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background-color: transparent;
    border: none;
    color: #ffffff;
    font-size: 28px;
    cursor: pointer;
    opacity: 0.7;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      opacity: 1;
      color: #ff4d4f;
      transform: scale(1.1);
    }
  }

  h1 {
    font-size: 22px;
    color: #ffffff;
    font-family: 'Montserrat', sans-serif;
    margin-bottom: 8px;
    font-weight: 700;
  }

  p {
    color: #cbd5e1;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 24px;
  }

  .down-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    a {
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 12px;
      color: #0f172a;
      font-weight: 600;
      font-family: 'Montserrat', sans-serif;
      font-size: 15px;
      padding: 16px;
      border-radius: 12px;
      background-color: #a6c10b;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 2px solid transparent;
      .badge {
        font-size: 10px;
        font-weight: 800;
        text-transform: uppercase;
        padding: 4px 8px;
        border-radius: 6px;
        letter-spacing: 0.5px;
      }

      .badge.beta {
        background-color: #3b82f6;
        color: #ffffff;
      }

      .badge.new {
        background-color: #ef4444;
        color: #ffffff;
        animation: pulse 2s infinite;
      }

      @keyframes pulse {
        0% {
          box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
        }
        70% {
          box-shadow: 0 0 0 6px rgba(239, 68, 68, 0);
        }
        100% {
          box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
        }
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(166, 193, 11, 0.4);
        background-color: #b7d50c;
      }

      svg,
      img {
        flex-shrink: 0;
      }
    }
  }
`
